import type { LogicSettingsPanelCombinedProps } from './types';

const usePresenter = (props: LogicSettingsPanelCombinedProps): LogicSettingsPanelCombinedProps => {
  return props;
};

export default usePresenter;
